<script lang="ts">
  export const name = 'Minus';
  export let className = '';
</script>

<svg class={className} viewBox="0 0 15 2" xmlns="http://www.w3.org/2000/svg">
  <rect width="15" height="2" rx="1" />
</svg>
